import React from "react";

function Product({ title, bg }: { bg: string; title?: string }) {
  return (
    <div className="flex flex-col gap-2 w-[250px]">
      <div className="relative grid place-items-center cursor-pointer">
        <div className="bg-transparent border-2 border-black/20 grid place-items-center h-[350px] w-[250px]">
          <div className="relative h-[330px] w-[230px] i-con overflow-hidden">
            <div
              className={`${bg} i-bg bg-cover bg-center relative z-30 h-[330px] w-[230px]`}
            ></div>
            <div className="bg-black/30 absolute opacity-0 i-ov h-full w-full top-0 z-30 grid place-items-center">
              <button className="bg-black mt-10 hover:bg-white hover:text-black font-semibold text-white px-6 py-2 uppercase text-sm tracking-wide">
                Buy Now
              </button>
            </div>
          </div>
        </div>
      </div>
      <p className="text-sm font-semibold hover:underline cursor-pointer">
        {/* {title?.length < 0 ? title : "fjfk"} */}
        BUTTA DROP WHIPPED OIL BODY CREAM WITH TROPICAL OILS + SHEA BUTTER
      </p>
    </div>
  );
}

export default Product;
